<template>
  <div>
    <table class="table table-sm">
      <thead>
        <tr>
          <th style="width:34%">Variant <small class="text-muted">(build manifest)</small></th>
          <th v-if="showSlideLists" style="width:30%">
            Slide list
            <i
              class="fa fa-question-circle text-muted"
              title="The slide-type list the picker shows for this arm."
            ></i>
          </th>
          <th>Weight</th>
          <th>Control</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(arm, index) in arms" :key="index">
          <td>
            <multiselect
              v-model="arm.variantKey"
              :options="variants"
              placeholder="Search a variant"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
            />
            <small v-if="arm.variantKey && variants.indexOf(arm.variantKey) === -1" class="text-danger">
              not in build
            </small>
          </td>
          <td v-if="showSlideLists">
            <b-form-select v-model="arm.segmentKey" size="sm" :options="slideListOptions(arm.segmentKey)" />
            <small v-if="arm.segmentKey && slideLists.length && slideLists.indexOf(arm.segmentKey) === -1" class="text-danger">
              no slide list with this name
            </small>
          </td>
          <td><input v-model.number="arm.weight" type="number" min="0" class="form-control form-control-sm" /></td>
          <td class="text-center align-middle">
            <input type="radio" :checked="arm.isControl" @change="$emit('control', index)" />
          </td>
          <td class="align-middle">
            <button type="button" class="btn btn-link btn-sm text-danger p-0" @click="$emit('remove', index)">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-sm btn-outline-secondary" @click="$emit('add')">
      <i class="fa fa-plus"></i> Add arm
    </button>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"

export default {
  name: "ArmsEditor",
  components: { Multiselect },
  props: {
    arms: { type: Array, required: true },
    variants: { type: Array, required: true },
    slideLists: { type: Array, default: () => [] },
    // Slide lists only steer the onboarding screen's slide picker.
    showSlideLists: { type: Boolean, default: true },
  },
  methods: {
    slideListOptions(current) {
      const options = [{ value: null, text: "Default picker (none)" }].concat(
        this.slideLists.map((segmentKey) => ({ value: segmentKey, text: segmentKey }))
      )
      if (current && this.slideLists.indexOf(current) === -1) {
        options.push({ value: current, text: current + " (not found)" })
      }
      return options
    },
  },
}
</script>
